<template>
    <div>
        <!-- 吸顶导航 -->
        <van-sticky>
            <van-nav-bar style="background-color: #3f78f6; margin-bottom: 0rem;border:0" title="" left-text=""
                left-arrow @click-left="onClickLeft">
                <template #title>
                    <span style="color: white;font-size: .4rem;">照片上传</span>
                </template>
                <template #left>
                    <van-icon name="arrow-left" color="white" size="18" />
                </template>
            </van-nav-bar>
        </van-sticky>
        <section class="van-doc-demo-section">
            <!-- <div class="locusItems">
                <table border="0" style="font-size:.4rem;margin:0 .5rem">
                    <tr>
                        <td colspan="2" style="color:red;font-size:.4rem">系统提示:<br>如果需要上传新得识别照片，请仔细阅读上传须知。此功能请谨慎使用。</td>
                    </tr>
                </table>
            </div> -->
            <div class="locusItems">
                <table border="0" style="font-size:.4rem;margin:0 .5rem;width:90%">
                    <tr>
                        <td style="color:#666666;font-size:.4rem">当前照片：</td>
                    </tr>
                    <tr>
                        <td style="text-align:center">
                            <van-image fit="fill" :src="imageurl" width="3rem" height="3rem" round />
                        </td>
                    </tr>
                </table>
            </div>
            <div class="locusItems">
                <table border="0" style="font-size:.4rem;margin:0 .5rem;width:90%">
                    <tr>
                        <td style="color:#666666;font-size:.4rem">上传照片：</td>
                    </tr>
                    <tr>
                        <td style="text-align:center">
                            <van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead" />
                        </td>
                    </tr>
                </table>
            </div>
            <div style="margin: 16px;margin-top:40px">
                <van-button round block icon="plus" type="primary" :disabled="this.tag" :loading="this.loadtag"
                    :loading-text="this.loadtext" style="font-size:.4rem" @click="uploadImage()">
                    上传文件
                </van-button>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                student: "",
                page: "",
                imageurl: "",
                fileList: [],
                file: "",
                tag: false,
                loadtag: false,
                loadtext: "",
            };
        },
        created() {
            this.student = this.$route.query.student;
            this.page = this.$route.query.page;
            console.log(this.student + "----------------" + this.page);
            this.init();
        },
        methods: {
            init() {
                var json = window.localStorage.getItem("User");
                var jsonObj = JSON.parse(json);
                console.log("身份:" + jsonObj[0]["shenfen"]);
                // var code;
                // if (jsonObj[0]["shenfen"] == "老师") {
                //     code = jsonObj[0]["number"];
                // } else if (jsonObj[0]["shenfen"] == "学生") {
                //     code = jsonObj[0]["number"];
                // } else {
                //     code = jsonObj[0]["phone"];
                // }
     if(window.localStorage.getItem( this.student)== "" ||window.localStorage.getItem( this.student)== "undefined" || window.localStorage.getItem( this.student)==  null || window.localStorage.getItem( this.student) == "null")
        {
           this.imageurl = require('@/image/hread.png');
        }
        else
        {
               this.imageurl =window.localStorage.getItem( this.student ); 
        }
                // var params_json = {
                //     userid: code,
                //     action: "getPic",
                //     param1: this.student,
                //     param2: "",
                //     param3: "",
                //     param4: "",
                //     param5: ""
                // };
                // this.$http
                //     .post("/web/list", params_json)
                //     .then(function (res) {
                //         console.log(res.data["rows"]);
                //         if (res.data["rows"].length > 0) {
                //             this.imageurl = res.data["rows"][0]["pic"];
                //         } else {
                //             console.log(res.data["rows"][0]["pic"]);
                //         }
                //     });
            },
            afterRead(file) {
                // 此时可以自行将文件上传至服务器
                this.file = file;
            },
            uploadImage() {
                var json = window.localStorage.getItem("User");
                var jsonObj = JSON.parse(json);
                console.log("身份:" + jsonObj[0]["shenfen"]);
                if (this.file == null || this.file == "") {
                    this.$notify({
                        type: "danger",
                        message: "上传照片不能为空."
                    });
                } else {
                    this.loadtag = true;
                    this.tag = true;
                    this.loadtext = "上传中照片中......";
                    var params_json = {
                        pid: this.student,
                        type: jsonObj[0]["shenfen"],
                        pic: this.file.content,
                    };
                    this.$http
                        .post("/web/uploadPic", params_json)
                        .then(function (res) {
                            let obj = res.data;
                            console.log("注册后返回消息:" + obj.msg);
                            if (obj.msg == "0") {
                                this.$notify({
                                    type: "success",
                                    message: "照片上传成功."
                                });
                                 window.localStorage.setItem( this.student,  this.file.content); 
                                 this.imageurl = this.file.content;
                                // this.init();
                            } else {
                                this.$notify({
                                    type: "warning",
                                    message: obj.msg
                                });
                            }
                            this.loadtag = false;
                            this.tag = false;
                            this.loadtext = "";
                        });
                }
            },
            onClickLeft() {
                // this.$router.push("MyTeacher");
                this.$router.push({
                    path: "MyTeacher",
                    query: {
                        student: this.student,
                        page: this.page
                    }
                });
            },
        }
    }
</script>
<style>
    .van-doc-demo-block__title {
        margin: 0;
        padding: 32px 16px 16px;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
    }

    .van-doc-demo-block__card {
        margin: 12px 12px 0;
        overflow: hidden;
        border-radius: 8px;
    }

    .van-doc-demo-block__title+.van-doc-demo-block__card {
        margin-top: 0;
    }

    .van-doc-demo-block:first-of-type .van-doc-demo-block__title {
        padding-top: 20px;
    }
</style>
<style>
    .demo-col {
        background: #fff;
    }

    .demo-col .van-doc-demo-block {
        padding: 0 16px;
    }

    .demo-col .van-doc-demo-block__title {
        padding-left: 0;
    }

    .demo-col .van-col {
        margin-bottom: 10px;
        color: #fff;
        font-size: 13px;
        line-height: 30px;
        text-align: center;
        background-clip: content-box;
    }

    .demo-col .van-col:nth-child(odd) {
        background-color: #39a9ed;
    }

    .demo-col .van-col:nth-child(even) {
        background-color: #66c6f2;
    }
</style>